module.exports = __webpack_public_path__ + "img/modal-login-default.94970ae3.svg";